import { useEffect, useState } from "react";
import { config } from "../../utils/config";
import { getCookie } from "../../utils/cookieHandler";
import axios from "axios";
import { PropagateLoader } from "react-spinners";
import dayjs from "dayjs";

const ChangelogsPage = () => {
  const [changelogs, setChangelogs] = useState(null);
  useEffect(() => {
    const fetchChangelogs = async () => {
      try {
        const changelogsRes = await axios.get(
          `${config.apiUrl}/api/changelogs/`,
          {
            headers: {
              Authorization: `Bearer ${getCookie("_AT")}`,
            },
          }
        );

        setChangelogs(changelogsRes.data);
      } catch (error) {
        console.error("Error fetching changelogs:", error);
      }
    };

    fetchChangelogs();
  }, []);

  return (
    <>
      {changelogs != null ? (
        <div className="space-y-4 ">
          {changelogs.map((log) => {
            return (
              <div key={Math.random()} className="space-y-2">
                <div className="flex gap-2 items-end ">
                  <div className="font-bold text-2xl leading-6">
                    Version: {log.version}
                  </div>
                  <div className="text-xs ">
                    {dayjs(log.date_created).format("DD/MM/YYYY HH:mm")}
                  </div>
                </div>
                <div className="space-y-4 mx-4 ">
                  {log.changes.map((change) => {
                    return (
                      <div key={change.id}>
                        <div className="text-xl font-semibold">
                          {change.type}:
                        </div>
                        <div className="mx-4 mt-1 flex flex-col">
                          {change.change_description
                            .split("&")
                            .map((element) => {
                              return <div>{element}</div>;
                            })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="flex justify-center ">
          <PropagateLoader />
        </div>
      )}
    </>
  );
};

export default ChangelogsPage;
